import React from 'react';


const Privacy = () => {
	return (
		<div className="container">
		  <h1>Ecoplug Energy India Limited Return Policy</h1>
		  <p>Last updated July 01, 2024</p>
		  <br />
		  <p>
		    Thank you for your purchase. We hope you are happy with your purchase.
		    However, if you are not completely satisfied with your purchase for any
		    reason, you may return it to us for a full refund only. Please see below for
		    more information on our return policy.
		  </p>
		  <br />
		  <h2>RETURNS</h2>
		  <p>
		    All returns must be postmarked within thirty (30) days of the purchase date.
		    All returned items must be in new and unused condition, with all original
		    tags and labels attached.
		  </p>
		  <br />
		  <h2>RETURN PROCESS</h2>
		  <p>
		    To return an item, please email customer service at{" "}
		    <a href="mailto:support@ecoplug.in">support@ecoplug.in</a> to obtain a
		    Return Merchandise Authorization (RMA) number. After receiving an RMA
		    number, place the item securely in its original packaging and mail your
		    return to the following address:
		  </p>
		  <address>
		    Ecoplug Energy India Limited (ECO PLUG)
		    <br />
		    Attn: Returns
		    <br />
		    RMA #<br />
		    Kh. 147, Rath Nagar, Ballaboda, Alwar
		    <br />
		    Alwar, Rajasthan 301001
		    <br />
		    India
		  </address>
		  <br />
		  <p>
		    You may also use the prepaid shipping label enclosed with your package.
		    Return shipping charges will be paid or reimbursed by us.
		  </p>
		  <br />
		  <h2>REFUNDS</h2>
		  <p>
		    Once we receive your returned item and assess its condition, we will initiate the refund process. Please allow up to 7 days from the date we receive your return for the refund to be processed. Depending on your payment method, the refund may take 7 days cycles to reflect in your account. We'll notify you via email as soon as your refund has been completed
		  </p>
		  <br />
		  <h2>EXCEPTIONS</h2>
		  <p>The following items cannot be returned:</p>
		  <ul>
		    <li>Money Added for charging EV Car</li>
		  </ul>
		  <br />
		  <p>
		    For defective or damaged products, please contact us at the contact details
		    below to arrange a refund or exchange.
		  </p>
		  <br />
		  <p>Please Note:</p>
		  <ul>
		    <li>Eco Plug Terms and Conditions as per Agreement</li>
		  </ul>
		  <br />
		  <h2>QUESTIONS</h2>
		  <p>
		    If you have any questions concerning our return policy, please contact us
		    at:
		  </p>
		  <p>
		    <a href="tel:9119115675">9119115675</a>
		    <br />
		    <a href="mailto:support@ecoplug.in">support@ecoplug.in</a>
		  </p>
		</div>



	)
}

export default Privacy;